import { service } from '../../../../helpers/http'

export const ActionGetDynamicTimeBalances = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'getDynamicTimeBalances',
        payload: payload
    })
    
}

export const ActionPostDynamicTimeBalance = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'postDynamicTimeBalance',
        payload: payload
    })
    
}

export const ActionPutDynamicTimeBalance = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'putDynamicTimeBalance',
        payload: payload
    })
    
}

export const ActionDeleteDynamicTimeBalance = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'deleteDynamicTimeBalance',
        payload: payload
    })
    
}

export const ActionDynamicTimeBalanceGenerate = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'putDynamicTimeBalanceGenerate',
        payload: payload
    })
    
}

export const ActionDynamicTimeBalanceSync = ({ dispatch }, payload) => {

    return service({
        module: 'domainDynamicTimeBalance',
        action: 'putDynamicTimeBalanceSync',
        payload: payload
    })
    
}